export const ANNOTATION_MODE_START = 'ANNOTATION_MODE_START';
export const ANNOTATION_MODE_END = 'ANNOTATION_MODE_END';
